import React, {useState} from 'react'
import './ManageAI.scss'
import TabBar from '../../Custom UI/TabBar/TabBar';
import {Translation} from "react-i18next";
import SecondaryHeader from '../../Custom UI/Headers/SecondaryHeader/SecondaryHeader';
import AIList from "../../Lists/AIList/AIList";

const ManageAI = ({user, company, removeAI, removeAIDocument, addAI, client, addAIDocument, addAIMessage,
                    fetchAI, fetchAIs, fetchAIDocuments, fetchAIMessages}) => {
  
  // Instance Variables
  
  const [tabBarKey, setTabBarKey] = useState('AI');
  const [hasSetTabFromParams, setHasSetTabFromParams] = useState(false);
  
  if(!hasSetTabFromParams){
    setHasSetTabFromParams(true);
    const paramTab = new URLSearchParams(window.location.search).get('tab');
    
    // TODO: Set params tab accordingly.
    // if(paramTab && paramTab >= 0 && paramTab <= 3){
    //   setTabBarKey(Number(paramTab));
    // }
  }
  
  // Render
  
  return (
    <div className='main-panel-inner-container'>
      <SecondaryHeader title={<Translation>{ (t, { i18n }) => t('AI_MODELS') }</Translation>}/>
  
      <TabBar tabBarTabsArray={[{key:'AI'}]}
              initialSelectedTabKey={'SCHEDULES'}
              selectedTabKeyChanged={(aKey) => setTabBarKey(aKey)}
      />
      
      {tabBarKey === 'AI' ?
        <AIList user={user}
                addAI={addAI}
                client={client}
                company={company}
                fetchAI={fetchAI}
                fetchAIs={fetchAIs}
                removeAI={removeAI}
                addAIMessage={addAIMessage}
                addAIDocument={addAIDocument}
                fetchAIMessages={fetchAIMessages}
                fetchAIDocuments={fetchAIDocuments}
                removeAIDocument={removeAIDocument}
        />
        :
        null
      }
    </div>
  )
};

export default ManageAI
